import { Record, Union } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { array_type, record_type, bool_type, option_type, float64_type, int32_type, string_type, unit_type, union_type, lambda_type, class_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Security_ResetPasswordViewModel_get_empty, Security_UserInfo$2_$reflection, Security_AuthErrorMessage_$reflection, Security_LoginResponse_$reflection, Security_ResetPasswordViewModel_$reflection, Security_LoginViewModel_$reflection, Security_RegisterViewModel_$reflection } from "../fable_modules/Webbler.Models.1.6.0/Api.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.19.3/Result.js";
import { UserRole_$reflection, UserData_$reflection } from "../RAWMap.Models/Security.js";
import { Notification_$reflection } from "../RAWMap.Models/Api.js";
import { MfaResendResponse_$reflection, MfaChallengeError_$reflection, MfaVerifyResponse_$reflection } from "../fable_modules/Webbler.Models.1.6.0/MfaChallenge.fs.js";
import { SessionManagement_SessionManagementModel_$reflection, SessionManagementMsg_$reflection } from "../Session.js";
import { join, printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";
import { compare } from "../fable_modules/fable-library-js.4.19.3/Date.js";
import { utcNow } from "../fable_modules/fable-library-js.4.19.3/DateOffset.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "SetRegisterVm", "SetLoginVm", "SetResetPasswordVm", "SendLogin", "GotLoginResponse", "SendLogout", "GetUserInfo", "GotUserInfoResponse", "GotLogoutResponse", "SendRegister", "GotRegisterResponse", "SendReset", "GotResetResponse", "EditResetRequestEmail", "SendResetRequest", "Authenticated", "Notification", "SetMfaCodeDigit", "SendMfaVerify", "GotMfaVerifyResponse", "SendMfaResend", "GotMfaResendResponse", "MfaSessionTick", "SetMfaCooldownTimerId", "ClearMfaState", "SessionManagementMsg", "SetInactivityPrompt", "TryShowLogoutWarning"];
    }
}

export function Msg_$reflection() {
    return union_type("Client.Auth.Types.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [["Item", lambda_type(Security_RegisterViewModel_$reflection(), Security_RegisterViewModel_$reflection())]], [["Item", lambda_type(Security_LoginViewModel_$reflection(), Security_LoginViewModel_$reflection())]], [["Item", lambda_type(Security_ResetPasswordViewModel_$reflection(), Security_ResetPasswordViewModel_$reflection())]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Security_LoginResponse_$reflection(), Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", Security_LoginResponse_$reflection()]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [UserData_$reflection(), Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", UserData_$reflection()]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]], [["Item", string_type]], [], [["Item", Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection())]], [["Item", Notification_$reflection()]], [["index", int32_type], ["digit", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [MfaVerifyResponse_$reflection(), MfaChallengeError_$reflection()], FSharpResult$2, () => [[["ResultValue", MfaVerifyResponse_$reflection()]], [["ErrorValue", MfaChallengeError_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [MfaResendResponse_$reflection(), MfaChallengeError_$reflection()], FSharpResult$2, () => [[["ResultValue", MfaResendResponse_$reflection()]], [["ErrorValue", MfaChallengeError_$reflection()]]])]], [], [["Item", option_type(float64_type)]], [], [["Item", SessionManagementMsg_$reflection()]], [["Item", bool_type]], []]);
}

export class InactivityModel extends Record {
    constructor(isActive, message, button) {
        super();
        this.isActive = isActive;
        this.message = message;
        this.button = button;
    }
}

export function InactivityModel_$reflection() {
    return record_type("Client.Auth.Types.InactivityModel", [], InactivityModel, () => [["isActive", bool_type], ["message", string_type], ["button", string_type]]);
}

export function InactivityModel_get_timeUntilWarning() {
    return 10 * 60;
}

export function InactivityModel_get_timeUntilLogout() {
    return 60;
}

export function InactivityModel_get_warning() {
    let arg;
    return new InactivityModel(true, (arg = (InactivityModel_get_timeUntilLogout() | 0), toText(printf("Are you still there? You will be logged out after %d seconds"))(arg)), "Keep me logged in");
}

export function InactivityModel_get_loggedOut() {
    return new InactivityModel(true, "You have been logged out due to inactivity", "Ok");
}

export function InactivityModel_get_init() {
    const bind$0040 = InactivityModel_get_warning();
    return new InactivityModel(false, bind$0040.message, bind$0040.button);
}

export function InactivityModel_get_isActive_() {
    return [(m) => m.isActive, (v) => ((m_1) => (new InactivityModel(v, m_1.message, m_1.button)))];
}

export class ResetPasswordModel extends Record {
    constructor(resetPasswordVm, resetRequestEmail, hideResetEmail) {
        super();
        this.resetPasswordVm = resetPasswordVm;
        this.resetRequestEmail = resetRequestEmail;
        this.hideResetEmail = hideResetEmail;
    }
}

export function ResetPasswordModel_$reflection() {
    return record_type("Client.Auth.Types.ResetPasswordModel", [], ResetPasswordModel, () => [["resetPasswordVm", Security_ResetPasswordViewModel_$reflection()], ["resetRequestEmail", string_type], ["hideResetEmail", bool_type]]);
}

export function ResetPasswordModel_get_empty() {
    return new ResetPasswordModel(Security_ResetPasswordViewModel_get_empty(), "", false);
}

export class MfaModel extends Record {
    constructor(MfaPendingToken, MfaChallengeId, MfaCodeDigits, MfaExpiresAt, MfaCooldownSeconds, MfaCooldownTimerId, MfaError, MfaIsVerifying) {
        super();
        this.MfaPendingToken = MfaPendingToken;
        this.MfaChallengeId = MfaChallengeId;
        this.MfaCodeDigits = MfaCodeDigits;
        this.MfaExpiresAt = MfaExpiresAt;
        this.MfaCooldownSeconds = MfaCooldownSeconds;
        this.MfaCooldownTimerId = MfaCooldownTimerId;
        this.MfaError = MfaError;
        this.MfaIsVerifying = MfaIsVerifying;
    }
}

export function MfaModel_$reflection() {
    return record_type("Client.Auth.Types.MfaModel", [], MfaModel, () => [["MfaPendingToken", option_type(string_type)], ["MfaChallengeId", option_type(class_type("System.Guid"))], ["MfaCodeDigits", array_type(string_type)], ["MfaExpiresAt", option_type(class_type("System.DateTimeOffset"))], ["MfaCooldownSeconds", option_type(int32_type)], ["MfaCooldownTimerId", option_type(float64_type)], ["MfaError", option_type(string_type)], ["MfaIsVerifying", bool_type]]);
}

export function MfaModel_get_empty() {
    return new MfaModel(undefined, undefined, MfaModel_get_emptyMfaCode(), undefined, undefined, undefined, undefined, false);
}

export function MfaModel_get_emptyMfaCode() {
    return ["", "", "", "", "", ""];
}

export function MfaModel__get_MfaCode(this$) {
    return join("", this$.MfaCodeDigits);
}

export class Model extends Record {
    constructor(loginVm, registerVm, resetPasswordModel, userInfo, sessionManagement, mfaModel, logoutConfirmedUntil, inactivity) {
        super();
        this.loginVm = loginVm;
        this.registerVm = registerVm;
        this.resetPasswordModel = resetPasswordModel;
        this.userInfo = userInfo;
        this.sessionManagement = sessionManagement;
        this.mfaModel = mfaModel;
        this.logoutConfirmedUntil = logoutConfirmedUntil;
        this.inactivity = inactivity;
    }
}

export function Model_$reflection() {
    return record_type("Client.Auth.Types.Model", [], Model, () => [["loginVm", Security_LoginViewModel_$reflection()], ["registerVm", Security_RegisterViewModel_$reflection()], ["resetPasswordModel", ResetPasswordModel_$reflection()], ["userInfo", option_type(Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection()))], ["sessionManagement", SessionManagement_SessionManagementModel_$reflection()], ["mfaModel", MfaModel_$reflection()], ["logoutConfirmedUntil", class_type("System.DateTimeOffset")], ["inactivity", InactivityModel_$reflection()]]);
}

export function Model_get_inactivity_() {
    return [(m) => m.inactivity, (v) => ((m_1) => (new Model(m_1.loginVm, m_1.registerVm, m_1.resetPasswordModel, m_1.userInfo, m_1.sessionManagement, m_1.mfaModel, m_1.logoutConfirmedUntil, v)))];
}

export function Model_get_mfa_() {
    return [(m) => m.mfaModel, (v) => ((m_1) => (new Model(m_1.loginVm, m_1.registerVm, m_1.resetPasswordModel, m_1.userInfo, m_1.sessionManagement, v, m_1.logoutConfirmedUntil, m_1.inactivity)))];
}

export function Model__get_isLogoutConfirmed(this$) {
    return compare(utcNow(), this$.logoutConfirmedUntil) < 0;
}

